import { serverURL } from "../utils";

let headers = {
  "Content-Type": "application/json",
};

export const updateStatus = async ({ orderNumber, status, tracking }) => {
  const response = await fetch(`${serverURL()}/orders/status`, {
    method: "PATCH",
    headers,
    body: JSON.stringify({ orderNumber, status, tracking }),
  });
  const newStatus = await response.json();
  return newStatus;
};

export const createReturn = async (returnObj) => {
  const response = await fetch(`${serverURL()}/orders/return`, {
    method: "POST",
    headers,
    body: JSON.stringify(returnObj),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  const returnResponse = await response.json();
  return returnResponse;
};

export const updateShippingRate = async (updateObj) => {
  const response = await fetch(`${serverURL()}/orders/update-pi`, {
    method: "POST",
    headers,
    body: JSON.stringify(updateObj),
  });
  const updateResponse = await response.json();
  return updateResponse;
};

export const createOrder = async (userId, cart, paymentIntentId) => {
  const response = await fetch(`${serverURL()}/orders`, {
    method: "POST",
    headers,
    body: JSON.stringify({ userId, cart, paymentIntentId }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  const orderNumber = await response.json();
  return orderNumber;
};

export const getCustomerOrder = async (orderNumber, email) => {
  const response = await fetch(`${serverURL()}/orders/lookup/${orderNumber}/${email}`, {
    method: "GET",
    headers,
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  const order = await response.json();
  return order;
};

async function checkAWSUrl(url) {
  try {
    const response = await fetch(url, { method: "GET" });
    if (response.ok) {
      return true; // URL exists and is accessible
    } else {
      return false; // URL doesn't exist or other error occurred
    }
  } catch (error) {
    return false; // Error during the request, assume URL doesn't exist or isn't accessible
  }
}

export const downloadReturnLabel = async (label) => {
  const response = await fetch(`${serverURL()}/orders/downloadReturnLabel/${label}`, {
    method: "GET",
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  }
  const returnLabel = await response.json();

  const result = checkAWSUrl(returnLabel).then((exists) => {
    if (exists) {
      return returnLabel;
    } else {
      return null;
    }
  });

  return result;
};

// USPS ADDRESS VALIDATION

export const checkAddress = async (address) => {
  const response = await fetch(`${serverURL()}/usps/address-check/${JSON.stringify(address)}`, {
    method: "GET",
    credentials: "include",
    headers,
  });
  const addressDetails = await response.json();
  return addressDetails;
};

export const getShippingFee = async (origin, destination) => {
  const response = await fetch(`${serverURL()}/usps/prices/${origin}/${destination}`, {
    method: "POST",
    credentials: "include",
    headers,
  });
  const shippingFee = await response.json();
  return shippingFee;
};

export const getSalesTaxRate = async (address) => {
  const response = await fetch(`${serverURL()}/usps/sales-tax-rate/${JSON.stringify(address)}`, {
    method: "GET",
    headers,
  });
  const taxRate = await response.json();
  return taxRate;
};
